(function () {
    'use strict';
    angular
        .module('app')
        .controller('autoNameDialog', autoNameDialog);
    autoNameDialog.$inject = ['$rootScope', '$scope', '$mdDialog', 'loginService', '$timeout', 'autoNameService', 'defaultExtension', 'numberOfDocuments'];
    function autoNameDialog($rootScope, scope, $mdDialog, loginService, $timeout, autoNameService, defaultExtension, numberOfDocuments) {
        scope.xyz = { textEnabled: false, comboEnabled: false, bReadyForOK: false };
        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        scope.xyz.autoNameDialogTitle = loginService.resourceStrings["AUTONAME"];
        scope.xyz.exampleNameTitle = loginService.resourceStrings["AUTONAME_EXAMPLENAME"];
        scope.xyz.exampleName = "";
        scope.xyz.autoNameList = [];
        scope.xyz.defaultExtension = "";
        scope.xyz.formatTitle = loginService.resourceStrings["AUTONAME_FORMAT"];
        scope.xyz.formatArray = [];
        scope.xyz.maxLength = 30;

        scope.xyz.enterTextTitle = loginService.resourceStrings["ENTER_TEXT"];
        scope.xyz.selectTextTitle = loginService.resourceStrings["SELECT_ITEM"];

        scope.OK = loginService.resourceStrings["OK"]; // "OK";
        scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";

        scope.items = []; // combo box on the right

        scope.loginService = loginService;
        var msgBoxType = -1;

        var SegmentTypeEnum = {
            AutoGenerated: 0,
            Delimiter: 1,
            Fixed: 2,
            Free: 3,
            DefinedList: 4,
            RestrictedField: 5,
            RelatedList: 6,
            FormatExtra: 999
        };

        scope.formatArray = [];
        autoNameService.GetAutoNameFormats().then(function (autoNameFormats) {
            angular.forEach(autoNameFormats, function (name, id) {
                scope.formatArray.push({ id: id, name: name })
            });
            if (scope.formatArray.length != 0) {
                scope.xyz.selectedFormat = scope.formatArray[0];
                scope.selectedFormatChanged();
            }
        });

        scope.selectedFormatChanged = function () {
            scope.xyz.textEnabled = false;
            scope.xyz.text = "";
            scope.xyz.comboEnabled = false;
            scope.xyz.selectedItem = null;

            scope.gridOptions.data = [];
            if (scope.xyz.selectedFormat != null) {
                var formatId = scope.xyz.selectedFormat.id;
                autoNameService.GetAutoNameFormat(formatId).then(function (autoNameFormatModel) {
                    scope.autoNameFormatModel = autoNameFormatModel;
                    console.log('AutoName: Format=' + autoNameFormatModel.formatName);
                    angular.forEach(autoNameFormatModel.segments, function (segment) {
                        var bAdd = false;
                        var name = "";
                        var val = "";
                        if (segment.segmentType == SegmentTypeEnum.AutoGenerated) {
                            // Start with current counter
                            var workingCounter = autoNameFormatModel.formatCounter;
                            if (workingCounter < segment.autoGeneratedSequenceLowerBound && workingCounter != -1)
                                workingCounter = segment.autoGeneratedSequenceLowerBound;

                            console.log('AutoName: AutoGenerated, workingCounter=' + workingCounter + ', UpperBound=' + segment.autoGeneratedSequenceUpperBound);
                            if (workingCounter >= segment.autoGeneratedSequenceUpperBound) {
                                var msg = loginService.resourceStrings["AUTONAME_RANGE_EXCEEDED"];
                                msg = msg.replace("{0}", scope.xyz.selectedFormat.name);
                                console.log('AutoName: Error=' + msg);
                                $rootScope.msgBoxShow(msg, loginService.resourceStrings["AUTONAME"], 3, true);
                                msgBoxType = 3;

                                for (var index = 0; index < scope.formatArray.length; ++index) {
                                    if (scope.formatArray[index].id === formatId) {
                                        scope.formatArray.splice(index, 1);
                                        if (scope.formatArray.length != 0) {
                                            scope.xyz.selectedFormat = scope.formatArray[0];
                                            scope.selectedFormatChanged();
                                        }
                                        break;
                                    }
                                }

                                return;
                            }

                            console.log('AutoName: AutoGenerated, workingCounter=' + workingCounter + ', MaxLength=' + segment.autoGeneratedSequenceLength);
                            if (workingCounter != -1 && workingCounter.toString().length > segment.autoGeneratedSequenceLength) {
                                var msg = loginService.resourceStrings["AUTONAME_COUNTER_EXCEEDED"];
                                msg = msg.replace("{0}", scope.xyz.selectedFormat.name);
                                $rootScope.msgBoxShow(msg, loginService.resourceStrings["AUTONAME"], 3, true);
                                msgBoxType = 3;

                                for (var index = 0; index < scope.formatArray.length; ++index) {
                                    if (scope.formatArray[index].id === formatId) {
                                        scope.formatArray.splice(index, 1);
                                        if (scope.formatArray.length != 0) {
                                            scope.xyz.selectedFormat = scope.formatArray[0];
                                            scope.selectedFormatChanged();
                                        }
                                        break;
                                    }
                                }
                                return;
                            }
                        }
                        else if (segment.segmentType == SegmentTypeEnum.Free) {
                            bAdd = true;
                            name = segment.freeTextName;
                            val = segment.freeTextValue;
                        }
                        else if (segment.segmentType == SegmentTypeEnum.DefinedList) {
                            // segment.definedListValues
                            bAdd = true;
                            name = segment.definedListName;
                            val = segment.definedListValues[0];
                        }
                        else if (segment.segmentType == SegmentTypeEnum.RestrictedField) {
                            // segment.restrictedListDefaultValue
                            // ??

                            bAdd = true;
                            name = segment.restrictedListName;
                            val = segment.restrictedListDefaultValue;
                        }
                        if (bAdd) {
                            segment.userData = val;
                            scope.gridOptions.data.push({
                                name: name, userInput: val, segment: segment
                            });
                        }
                    });

                    // Do Enables.
                    scope.doEnables();
                    refreshSample();
                });
            }
        }

        scope.onTextChanged = function () {
            var selectedRows = scope.gridApi.selection.getSelectedRows();
            if (selectedRows != null && selectedRows.length > 0) {
                var item = selectedRows[0];

                item.userInput = scope.xyz.text;
                item.segment.userData = item.userInput;
            }

            // Do Enables.
            scope.doEnables();
            refreshSample();
        }

        scope.selectedItemChanged = function () {
            if (scope.xyz.selectedItem != null) {
                var selectedRows = scope.gridApi.selection.getSelectedRows();
                if (selectedRows != null && selectedRows.length > 0) {
                    var item = selectedRows[0];

                    item.userInput = scope.xyz.selectedItem.name;
                    item.segment.userData = item.userInput;

                    // Validate the legth for defined lists
                    if (item.segment.segmentType == SegmentTypeEnum.DefinedList) {
                        ValidateInputLength(item.segment, item.userInput);
                    }
                }
            }

            // Do Enables.
            scope.doEnables();
            refreshSample();
        }

        //
        // Enables.
        //
        scope.doEnables = function () {
            var bReadyForOK = true;

            // If no format selected, then not ready.
            if (scope.xyz.selectedFormat == null) {
                bReadyForOK = false;
            }

            // If any item still needs input, then not ready.
            angular.forEach(scope.gridOptions.data, function (item) {
                if (item.userInput == null || item.userInput == ""){
                    bReadyForOK = false;
                }
                if (bReadyForOK === true) {
                    if (item.segment.segmentType === SegmentTypeEnum.Free) {
                        if (item.segment.freeTextMaximumLengthRequired === true && item.userInput.length < item.segment.freeTextLength) {
                            bReadyForOK = false;
                        }
                    }
                }
            });

            // Handle enabling OK.
            scope.xyz.bReadyForOK = bReadyForOK;
            return bReadyForOK;
        }

        var ValidateInputLength = function (segment, userInput) {
            autoNameService.ValidateInputLength(segment, userInput).then(function (response) {
                var validateStatus = response.data;
                if (validateStatus.Status == false) {
                    // Display warning
                    $rootScope.msgBoxShow(validateStatus.StatusMessage, loginService.resourceStrings["AUTONAME"], 2, true);
                    msgBoxType = 2;
                } else {
                    hideMsgBox(false);
                }
            }, function (response) { });
        }

        var refreshSample = function () {
            scope.xyz.exampleName = "";
            autoNameService.GetNextAutoNameSamples(numberOfDocuments, scope.autoNameFormatModel).then(function (response) {
                var sampleNames = response.data;
                if (sampleNames.Status != 0) {
                    $rootScope.msgBoxShow(sampleNames.StatusMessage, loginService.resourceStrings["AUTONAME"], 2, true);
                    msgBoxType = 2;
                } else {
                    hideMsgBox(false);
                }
                if (sampleNames.Samples != null && sampleNames.Samples.length > 0) {
                    scope.xyz.exampleName = sampleNames.Samples[0];
                    scope.xyz.defaultExtension = defaultExtension;
                    scope.xyz.autoNameList = sampleNames.Samples; //full array of all names requested; return when OK
                }
            }, function (response) { });
        }

        var hideMsgBox = function (force) {
            if (msgBoxType < 3 || force === true) {
                // Hide the toast msgbox
                $rootScope.msgBox.visible = false;
            }
        }

        scope.onAutoNameDialogOK = function () {
            hideMsgBox(true);

            if ($rootScope.dlgReturn == null)
                $rootScope.dlgReturn = {};
            $rootScope.dlgReturn.autoNameOK = true;
            $rootScope.dlgReturn.autoNameList = scope.xyz.autoNameList;
            $rootScope.dlgReturn.autoNameFormatModel = scope.autoNameFormatModel;
            // Close dialog.
            $mdDialog.hide();
        }

        scope.onAutoNameDialogCancel = function () {
            hideMsgBox(true);

            if ($rootScope.dlgReturn == null)
                $rootScope.dlgReturn = {};
            $rootScope.dlgReturn.autoNameOK = false;
            // Close dialog.
            $mdDialog.hide();
        }

        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        var selectThis = function (value) {
            if (value != null && value.length > 0) {
                angular.forEach(scope.items, function (item) {
                    if (item.name == value) {
                        scope.xyz.selectedItem = item;
                        return;
                    }
                });
            }
        }

        //
        // On selection changed in the grid.
        //
        scope.selectItem = function (item) {
            scope.xyz.textEnabled = false;
            scope.xyz.text = "";
            scope.xyz.comboEnabled = false;
            scope.xyz.selectedItem = null;
            var selectedRows = scope.gridApi.selection.getSelectedRows();
            if (selectedRows != null && selectedRows.length > 0) {
                var item = selectedRows[0];
                if (item.segment.segmentType == SegmentTypeEnum.Free) {
                    scope.xyz.text = item.userInput;
                    scope.xyz.textEnabled = true;
                    scope.xyz.maxLength = item.segment.freeTextLength
                }
                else if (item.segment.segmentType == SegmentTypeEnum.DefinedList) {
                    scope.items = [];
                    angular.forEach(item.segment.definedListValues, function (definedListValue) {
                        // Skip duplicates
                        var found = false;
                        for (var index = 0; index < scope.items.length; ++index) {
                            if (scope.items[index].name === definedListValue) {
                                found = true;
                                break;
                            }
                        }
                        if (!found)
                            scope.items.push({ name: definedListValue });
                    });
                    selectThis(item.userInput);
                    scope.xyz.comboEnabled = true;
                }
                else if (item.segment.segmentType == SegmentTypeEnum.RestrictedField) {
                    scope.items = [];
                    angular.forEach(item.segment.restrictedListValues, function (restrictedListValue) {
                        scope.items.push({ name: restrictedListValue });
                    });
                    selectThis(item.userInput);
                    scope.xyz.comboEnabled = true;
                }
            };

            // Do Enables.
            scope.doEnables();
        };

        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);

            ////after the grid has been initialized
            //switch (command) {
            //    case "assign":
            //        scope.onAssignButtonClicked(records);
            //        break;
            //    case "unassign":
            //        scope.onUnassignButtonClicked(records);
            //        break;
            //}

        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: false,
            modifierKeysToMultiSelect: true,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            useExternalSorting: true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: loginService.resourceStrings["AUTONAME_COL_SEGMENT"], field: 'name', width: '33%', minWidth: '100' },
                { name: loginService.resourceStrings["AUTONAME_COL_USERINPUT"], field: 'userInput', width: '33%', minWidth: '100' }],
            onRegisterApi: onRegisterApi
        }

        function activate() { }
        activate();
    }
})();
